import React from 'react';
import {
  faPhone,
  faMapMarker,
  faCopyright,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Logo } from '../components';
export const Footer = ({ className = '' }) => {
  return (
    <footer className={`py-5 FooterHeaderBackgroundImage ${className}`}>
      <div className="container">
        <div className="row">
          <div className="col-12 col-sm-6 col-lg-3 mb-4">
            <div className="text-center mb-3">
              <Logo alt="logo-footer" className="img-fluid" />
            </div>
            <div className="text-right">
              <p style={{ color: 'rgb(204,230,187)' }}>
                <FontAwesomeIcon icon={faMapMarker} /> فارس، شیراز، زرگری، چهارراه ستارخان،
                کوچه 19
              </p>
              
              
            </div>
            <div className='text-right'>
            <p style={{ color: 'rgb(204,230,187)' }}>
                <FontAwesomeIcon icon={faPhone} /> تلفن: 07136272898 (10 خط)
              </p>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-lg-3 mb-4">
            <h5 style={{ color: 'rgb(255,255,255)',fontSize:16,fontWeight:900 }} className="mb-3">
              خدمات
            </h5>
            <ul className="list-unstyled">
              <li>
                <a
                  className={'text-decoration-none'}
                  style={{ color: 'rgb(204,230,187)' }}
                  href="https://saloutieyeclinic.com/%d8%a7%d8%b5%d9%84%d8%a7%d8%ad-%d8%b9%db%8c%d9%88%d8%a8-%d8%a7%d9%86%da%a9%d8%b3%d8%a7%d8%b1%db%8c/"
                >
                  اصلاح عیوب انکساری
                </a>
              </li>
              <li>
                <a
                  className={'text-decoration-none'}
                  style={{ color: 'rgb(204,230,187)' }}
                  href="https://saloutieyeclinic.com/%d8%a2%d8%a8-%d9%85%d8%b1%d9%88%d8%a7%d8%b1%db%8c%d8%af/"
                >
                  اعمال جراحی
                </a>
              </li>
              <li>
                <a
                  className={'text-decoration-none'}
                  style={{ color: 'rgb(204,230,187)' }}
                  href="https://saloutieyeclinic.com/%d8%a8%d8%b1%d8%b1%d8%b3%db%8c-%d9%82%d8%b1%d9%86%db%8c%d9%87/"
                >
                  خدمات تشخیصی
                </a>
              </li>
            </ul>
          </div>
          <div className="col-12 col-sm-6 col-lg-3 mb-4">
            <h5 style={{ color: 'rgb(255,255,255)',fontSize:16,fontWeight:900 }} className="mb-3">
              دکتر صلوتی
            </h5>
            <ul className="list-unstyled">
              <li>
                <a
                  className={'text-decoration-none'}
                  style={{ color: 'rgb(204,230,187)' }}
                  href="https://saloutieyeclinic.com/%d8%b1%d8%b2%d9%88%d9%85%d9%87/"
                >
                  رزومه
                </a>
              </li>
              <li>
                <a
                  className={'text-decoration-none'}
                  style={{ color: 'rgb(204,230,187)' }}
                  href="https://saloutieyeclinic.com/%d8%a7%d9%81%d8%aa%d8%ae%d8%a7%d8%b1%d8%a7%d8%aa/"
                >
                  افتخارات
                </a>
              </li>
              <li>
                <a
                  className={'text-decoration-none'}
                  style={{ color: 'rgb(204,230,187)' }}
                  href="https://saloutieyeclinic.com/%d9%85%d9%82%d8%a7%d9%84%d8%a7%d8%aa/"
                >
                  مقالات
                </a>
              </li>
            </ul>
          </div>
          <div className="col-12 col-sm-6 col-lg-3 mb-4">
            <h5 style={{ color: 'rgb(255,255,255)' ,fontSize:16,fontWeight:900}} className="mb-3">
              دسترسی سریع
            </h5>
            <ul className="list-unstyled">
              <li>
                <a
                  className={'text-decoration-none'}
                  style={{ color: 'rgb(204,230,187)' }}
                  href="https://saloutieyeclinic.com/contact-us/"
                >
                  تماس با ما
                </a>
              </li>
              <li>
                <a
                  className={'text-decoration-none'}
                  style={{ color: 'rgb(204,230,187)' }}
                  href="https://saloutieyeclinic.com/%d8%ae%d8%af%d9%85%d8%a7%d8%aa-%d8%a2%d9%86%d9%84%d8%a7%db%8c%d9%86/"
                >
                  نوبت دهی اینترنتی
                </a>
              </li>
              <li>
                <a
                  className={'text-decoration-none'}
                  style={{ color: 'rgb(204,230,187)' }}
                  href="https://saloutieyeclinic.com/work-with-us/"
                >
                  همکاری با ما
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className={'d-flex align-items-center flex-column'}>
        <div>
          <p className="mb-1 text-white">تمامی حقوق محفوظ است.</p>
        </div>
        <p className="mb-0 text-white">
          Salouti Eye Clinic <FontAwesomeIcon icon={faCopyright} /> 2022
          designed by{' '}
          <br/>
          <a
            href="https://barinclinic.ir"
            className="text-white text-decoration-none"
          >
            طراحی و اجرا توسط شرکت پدیده فناوران برین عصر جدید
          </a>
        </p>
      </div>
    </footer>
  );
};
